import { render } from "./CreateTeamModal.vue?vue&type=template&id=74dde4b1&scoped=true"
import script from "./CreateTeamModal.vue?vue&type=script&lang=js"
export * from "./CreateTeamModal.vue?vue&type=script&lang=js"

import "./CreateTeamModal.vue?vue&type=style&index=0&id=74dde4b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dde4b1"]])

export default __exports__